<div class="w-full">
  <div class="grid grid-cols-1 md:grid-cols-3 gap-6 w-full" style="grid-auto-rows: 1fr;">
    <ape-status-card
      *ngFor="let item of countersCardData; trackBy: trackCardByIndex"
      [variant]="'gray'"
      [cardData]="item"
      [cssClass]="'overflow-auto'"
      class="w-full h-full"
    />
  </div>
</div>
